<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <el-form-item label="Size" prop="size" :rules="stringRule('size')">
      <el-select v-model="item.size">
        <el-option
          v-for="option in size_option"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <form-item-group
      title="Images"
      :min="marqueeImgMin"
      :max="marqueeImgMax"
      :group-item="CONSTANT.CREATIVE_DEFAULT_VALUE.MARQUEE.ITEM"
      v-model="item.images"
    >
      <template slot-scope="{ index }">
        <el-form-item
          label="Image"
          :prop="`images.${index}.url`"
          :rules="[
            ...imageSizeRule({
              width: checkImgWidth,
              height: checkImgHeight,
            }),
            ...urlRule('image_url'),
          ]"
          label-width="120px"
        >
          <file-input
            accept="image/jpeg, image/png, image/gif"
            v-model="item.images[index].url"
            :check_upload_image_size="{
              width: checkImgWidth,
              height: checkImgHeight,
              enable: true,
            }"
          ></file-input>
        </el-form-item>
      </template>
    </form-item-group>
    <el-form-item label="Bottom Offset" label-width="137px">
      <Offset v-model="item.offset_bottom"> </Offset>
    </el-form-item>
    <el-form-item label="MARQUEE type" label-width="137px">
      <el-select v-model="item.marqueeType">
        <el-option
          v-for="option in typeOptions"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="close button type" label-width="137px">
      <el-select v-model="item.closeBtnType">
        <el-option
          v-for="option in closeBtnOptions"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";

const { MARQUEE } = CONSTANT.CREATIVE_DEFAULT_VALUE;

export default {
  data() {
    return {
      item: {
        images: [...Array(MARQUEE.MIN_NUM)].map(() =>
          _.cloneDeep(MARQUEE.ITEM)
        ),
        offset_bottom: {
          number: "",
          unit: "px",
        },
        size: "320*100",
        marqueeType: CONSTANT.MARQUEE_TYPE.TRADITION,
        closeBtnType: 0,
        cacheImages: [],
      },
      size_option: [
        { label: "320 x 100",value: "320*100" },
        { label: "750 x 300", value: "750*300" },
      ],
      typeOptions: [
        { label: "TRADITION",value: CONSTANT.MARQUEE_TYPE.TRADITION },
        { label: "SPEED_CHANGE", value: CONSTANT.MARQUEE_TYPE.SPEED_CHANGE },
        { label: "STOP", value: CONSTANT.MARQUEE_TYPE.STOP },
      ],
      closeBtnOptions: [
        { label: "TRADITION",value: 0 },
        { label: "CLOSE_BUTTON_1", value: 1 },
      ],
    };
  },
  mixins: [MixFormRule, MixCreativeForm],
  computed: {
    checkImgWidth() {
      return {
        max: parseInt(this.item.size.split("*")[0]),
        min: parseInt(this.item.size.split("*")[0]),
      };
    },
    checkImgHeight() {
      return {
        max: parseInt(this.item.size.split("*")[1]),
        min: parseInt(this.item.size.split("*")[1]),
      };
    },
    marqueeImgMax() {
      return (this.item.marqueeType == CONSTANT.MARQUEE_TYPE.STOP) ? CONSTANT.CREATIVE_DEFAULT_VALUE.MARQUEE_STOP.MAX_NUM : CONSTANT.CREATIVE_DEFAULT_VALUE.MARQUEE.MAX_NUM;
    },
    marqueeImgMin() {
      return (this.item.marqueeType == CONSTANT.MARQUEE_TYPE.STOP) ? CONSTANT.CREATIVE_DEFAULT_VALUE.MARQUEE_STOP.MIN_NUM : CONSTANT.CREATIVE_DEFAULT_VALUE.MARQUEE.MIN_NUM;
    }
  },
  watch: {
    'item.marqueeType'(newVal, oldVal) {
      if (newVal == CONSTANT.MARQUEE_TYPE.STOP) {
        this.item.cacheImages = this.item.images.splice(1, this.item.images.length - 1);
      } else {
        if (this.item.cacheImages.length > 0) {
          this.item.images = [...this.item.images, ...this.item.cacheImages];
          this.item.cacheImages = [];
        }
      }
    },
  },
  methods: {
    setData(row) {
      this.item.images = _.map(row.images, (image) => {
        return {
          url: decodeURI(image.url),
        };
      });
      this.item.size = `${row.width}*${row.height}`;
      this.item.marqueeType = row.marqueeType;
      this.item.closeBtnType = row.closeBtnType;
      this.item.offset_bottom.unit = row.offset_bottom_unit;
      this.item.offset_bottom.number = row.offset_bottom_number;
    },
    async getData(setObj) {
      setObj.images = _.map(this.item.images, (image) => {
        return {
          url: image.url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
        };
      });
      setObj.offset_bottom_unit = this.item.offset_bottom.unit;
      setObj.offset_bottom_number = this.item.offset_bottom.number;
      setObj.width = parseInt(this.item.size.split("*")[0]);
      setObj.height = parseInt(this.item.size.split("*")[1]);
      setObj.marqueeType = this.item.marqueeType;
      setObj.closeBtnType = this.item.closeBtnType;
      return setObj;
    },
  },
};
</script>

<style></style>
